import React from 'react';
import styled from 'styled-components';
const ListItem = styled.li `
  line-height: 1;
`;
export const MobileOnlyNavigationItem = ({ children }) => (React.createElement(ListItem, null, children));
